export const mediaQueries = {
    TABLET: "@media (max-width: 1024px)",
    TABLETPORTRAIT: "@media (max-width: 1280px)",
    LAPTOP: "@media (max-width: 1368px)",
    MOBILE: "@media (max-width: 728px)",
};